export const EMPLOYER_FACILITY_ROUTES = {
  get: '/employer-facilities',
  post: '/employer-facilities',
  patch: '/employer-facilities/{employerFacilityId}',
  delete: '/employer-facilities/{employerFacilityId}',
};
